"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const styled_react_1 = require("../habit-icon/styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const HabitJourneyBadge = ({ habitJourney, className, }) => (
// eslint-disable-next-line react/no-unknown-property
(0, core_1.jsx)("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className), css: (0, styled_react_1.gradientColor)([habitJourney.primaryColor, habitJourney.secondaryColor]) },
    (0, core_1.jsx)("div", { className: styles_scss_1.default.content },
        (0, core_1.jsx)("div", { className: styles_scss_1.default.imageContainer },
            (0, core_1.jsx)("img", { src: habitJourney.icon.url.medium, alt: "", className: styles_scss_1.default.image })),
        (0, core_1.jsx)("span", { className: styles_scss_1.default.text, css: (0, styled_react_1.textColor)(habitJourney.primaryColor) }, habitJourney.title))));
HabitJourneyBadge.defaultProps = {
    className: undefined,
};
exports.default = HabitJourneyBadge;
